import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';

import styles from './testimonials.module.scss';

export const Testimonials = ({ data }) => (
	<div className={styles.wrapper}>
		<div className={styles.container}>
			<h2>{data.header}</h2>
			<div className={styles.items}>
				{data.items.map((item, key) => (
					<div key={key} className={styles.item}>
						<div className={styles.quote}>
							<em>{item.quote}</em>
						</div>

						<div className={styles.meta}>
							{item.image.file && (
								<div className={styles.image}>
									<GatsbyImage
										className={styles.img}
										alt={item.image.alt}
										title={item.image.title}
										image={item.image.file.childImageSharp.gatsbyImageData}
									/>
								</div>
							)}
							<div className={styles.person}>
								<div className={styles.name}>
									<strong>{item.name}</strong>
								</div>
								{item.position && <div className={styles.position}>{item.position}</div>}
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	</div>
);

Testimonials.defaultProps = {
	data: {},
};

Testimonials.propTypes = {
	data: PropTypes.object.isRequired,
};
